import { useParams } from "@tanstack/react-router";
import { useBoardStore } from "@/shared/stores/boardStore";

/**
 * 現在の board slug を返す。
 *
 * 1. URL に `$boardSlug` segment があればそれを返す（source of truth）
 * 2. 無ければ `boardStore` の永続値を fallback として返す
 *
 * 1 で得た値は store に書き戻さない（読み取り専用）。store は URL 外コンテキスト
 * （例: 設定画面・Top page）からの fallback 用途に限る。
 */
export function useCurrentBoardSlug(): string {
  const params = useParams({ strict: false }) as { boardSlug?: string };
  const storedSlug = useBoardStore((s) => s.slug);
  return params.boardSlug ?? storedSlug;
}
